// API Configuration
// Use backend on 6200 for local frontend (3200), production URL otherwise

// API URL from environment variable only
const API_URL = process.env.REACT_APP_API_URL;

export default API_URL;


